import { Fragment, useState, useEffect } from "react";
import { List, Avatar, Radio, notification, Upload } from "antd";
import { TitleHeader } from "../../components/commons";
import { InboxOutlined } from "@ant-design/icons";
import { getAllImportacion, executeUpdate } from "../../api/sistema";
import { uploadProps } from "../../utils/functions";
import IMAGE_EMPTY from "../../assets/empty.png";
import IMAGE_CHECK from "../../assets/check.png";
import moment from "moment";

const { Dragger } = Upload;

function Transferencia() {
  const [dataToTable, setDataToTable] = useState([]);
  const [reload, setReload] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [pathUpload, setPathUpload] = useState("/sistema/uploadv2");

  const fetchDataToTable = async () => {
    setIsLoading(true);

    getAllImportacion()
      .then((res) => {
        setDataToTable(res.payload);
      })
      .catch((err) => {
        notification.error({
          message: "Problemas con la solicitud",
          description: err.message
        });
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  useEffect(() => {
    fetchDataToTable();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reload]);

  const registerFileUploaded = (info) => {
    const filename = info.file.name.split(".")[0] || "";
    const contador = dataToTable.find((i) => i.archivo === filename)?.contador || 0;

    executeUpdate(
      {
        collection: "sys_importacion",
        nombreid: "archivo",
        valorid: filename
      },
      {
        subido: true,
        contador: contador + 1
      }
    )
      .then((res) => {
        if (res.success) {
          notification.success({
            message: "Operación exitosa",
            description: `Se ha subido el archivo satistactoriamente.`
          });
          fetchDataToTable();
        }
      })
      .catch(() => {
        notification.error({
          message: "Operación no válida",
          description: `No se pudo registrar la subida de archivo, comuníquese con el administrador.`
        });
      });
  };

  const onChangeFormaSubida = (e) => {
    setPathUpload(e.target.value);
  };

  return (
    <Fragment>
      <TitleHeader title="Carga de datos" />

      <div className="flex flex-wrap gap-5 md:flex-nowrap">
        <div className="w-full md:w-1/2">
          <List
            itemLayout="horizontal"
            dataSource={dataToTable}
            loading={isLoading}
            renderItem={(item) => (
              <List.Item>
                <List.Item.Meta
                  avatar={<Avatar src={item.subido ? IMAGE_CHECK : IMAGE_EMPTY} />}
                  title={
                    <div className="flex gap-4">
                      <span className="font-bold">
                        {item.archivo}{" "}
                        <span className="text-gray-500">({item.contador} veces)</span>
                      </span>
                      {item.subido ? (
                        <span>
                          subido el {moment(item.updatedAt).format("DD MMM YYYY - hh:mm a")}
                        </span>
                      ) : (
                        <span className="text-gray-400">vacío</span>
                      )}
                    </div>
                  }
                  description={item.descripcion}
                />
              </List.Item>
            )}
          />
        </div>
        <div className="w-full md:w-1/2">
          <Radio.Group onChange={onChangeFormaSubida} value={pathUpload} className="pb-2">
            <Radio value="/sistema/upload">Archivo excel</Radio>
            <Radio value="/sistema/upload-zip">Archivo zip</Radio>
            <Radio value="/sistema/upload-onesource">Excel x hojas</Radio>
          </Radio.Group>

          <Dragger
            {...uploadProps({
              name: "mas_archivo",
              action: pathUpload,
              maxSize: 2000, // 2gb
              makeReload: () => setReload(!reload),
              afterOnChange: (info) => registerFileUploaded(info)
            })}
            multiple
          >
            <p className="ant-upload-drag-icon">
              <InboxOutlined />
            </p>
            <p className="ant-upload-text">
              Haz click o arrastra un archivo para subirlo al sistema
            </p>
            <p className="ant-upload-hint p-2">
              En archivos excel se lee de la primera hoja, en zip solo formato zip a la carpeta ejm
              /fotos, en excel por hojas para subir por cada hoja del excel como si fuera una tabla.
            </p>
          </Dragger>
        </div>
      </div>
    </Fragment>
  );
}

export default Transferencia;
